import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import { Modal, Input } from 'antd'
import { Button } from 'components'
import { positionsApi } from 'api/positions'

import { getExpelTarget } from './helpers'

const { TextArea } = Input

const ExpelModal = ({ visible, position, user, reloadParent, close }) => {
	const [reasonValue, setReasonValue] = useState('')
	const [loading, setLoading] = useState(false)

	// When expelling from a position that holds multiple users, `user` targets
	// the specific user picked in the detail view. Fall back to the position's
	// current user for the single-user list/detail flows.
	const { user_email: targetEmail, user_name: targetName } = getExpelTarget(user, position)

	const handleDelete = async () => {
		setLoading(true)

		try {
			await positionsApi.expelUserFromPosition({
				position_id: position.position_id || '',
				user_email: targetEmail,
				reason: reasonValue || '',
			})
			close()
			setReasonValue('')
			reloadParent()
			Modal.success({
				title: 'User has been expel successfully',
			})
		} catch (err) {
			setLoading(false)
			console.error(err)
		}

		setLoading(false)
	}

	return (
		<Modal
			loading={loading}
			destroyOnClose
			title={<span style={{ fontWeight: 700 }}>Expel User</span>}
			visible={visible}
			onCancel={() => {
				close()
				setReasonValue('')
			}}
			footer={
				<div className="flex-end">
					<Button
						style={{ marginRight: '0.5em' }}
						onClick={() => {
							close()
							setReasonValue('')
						}}>
						Cancel
					</Button>
					<Button
						type="danger"
						htmlType="submit"
						loading={loading}
						disabled={!reasonValue}
						onClick={handleDelete}>
						Expel
					</Button>
				</div>
			}
			centered>
			<p style={{ fontSize: 16, textAlign: 'center' }}>
				Are you sure want Expel{' '}
				<b>{targetName || targetEmail || 'this user'}</b> from this position?
			</p>
			<p className="text-cf-14 mt-8 mb-4">
				Reason<span style={{ color: '#ac2f24' }}> *</span>
			</p>
			<TextArea
				rows={4}
				value={reasonValue}
				onChange={(e) => setReasonValue(e.target.value)}
			/>
		</Modal>
	)
}

export default withRouter(ExpelModal)
